<template>
    <div
        class="flex flex-col items-start gap-2 flex-1 px-4 py-5 sm:p-4 overflow-hidden md:rounded-lg"
    >
        <dt
            class="truncate text-lg font-medium text-slate-800 py-1 mb-3"
        >
            Total annual fees
        </dt>
        <dd class="mt-1 text-3xl font-medium text-slate-800 mb-1">
            <template v-if="annualFees > 0">
                <count-up
                    :end-val="annualFees"
                    :options="{ prefix: '$' }"
                ></count-up>
            </template>
            <template v-else>
                <hr class="w-4 border-slate-800 border-b-2 rounded-md text-3xl font-semibold text-slate-900 mb-3 mt-6">
            </template>
        </dd>
        <dt class="truncate text-sm font-medium text-slate-500">
            Annual fees
        </dt>
    </div>
</template>
<script>
import { mapState } from "pinia";
import { useDashboardStore } from "@/store/dashboard";
import CountUp from "vue-countup-v3";

export default {
    props: [],
    components: {
        CountUp,
    },
    computed: {
        ...mapState(useDashboardStore, ["loading", "annualFees"]),
    },
    data: () => ({}),
    methods: {},
    created() {},
    mounted() {},
};
</script>
